module.exports = __webpack_public_path__ + "img/oufu_120x140x13b.prt.92a2586e.jpg";